import { render, staticRenderFns } from "./invite-professional.vue?vue&type=template&id=8c7515b2&scoped=true&"
import script from "./invite-professional.vue?vue&type=script&lang=js&"
export * from "./invite-professional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c7515b2",
  null
  
)

export default component.exports